import { ref, watch } from 'vue'
import { fetchContacts } from '@/service/users'

export function useUserSearch(minChars = 2, debounceMs = 300) {
  const searchQuery = ref('')
  const userList = ref<{ id: string; name: string; email?: string; avatar?: string }[]>([])
  const isLoading = ref(false)
  let debounceTimer: ReturnType<typeof setTimeout> | null = null

  watch(searchQuery, (newVal) => {
    if (newVal.length < minChars) {
      userList.value = []
      isLoading.value = false
      if (debounceTimer) clearTimeout(debounceTimer)

      return
    }

    isLoading.value = true

    if (debounceTimer) clearTimeout(debounceTimer)

    debounceTimer = setTimeout(async () => {
      const { onSuccess, onError } = await fetchContacts(newVal)

      onSuccess((data) => {
        userList.value = data
        isLoading.value = false
      })

      onError(() => {
        userList.value = []
        isLoading.value = false
      })
    }, debounceMs)
  })

  const clearSearch = () => {
    searchQuery.value = ''
    userList.value = []
    isLoading.value = false
    if (debounceTimer) clearTimeout(debounceTimer)
  }

  return {
    searchQuery,
    userList,
    isLoading,
    clearSearch,
  }
}
